/**
 * Clears the app cart stored in localStorage ("Cart" key).
 * Dispatches a storage event so CartProvider rehydrates with an empty cart.
 * Matches the behavior of the cart page "Clear" button.
 */
export function clearAppCartStorage(): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem("Cart", "[]");
  window.dispatchEvent(new Event("storage"));
}
